<template>
	<div class="w-full h-full">
		<van-nav-bar
			left-text="返回"
            title="添加群管"
			left-arrow
			@click-left="$router.go(-1)"
		/>
		<van-form @submit="onSubmit" class="p-4">
			<van-cell-group inset>
				<van-field
					v-model="form.name"
					name="name"
					label="群管昵称"
					placeholder="请输入群管昵称"
					:rules="[{ required: true, message: '请填写群管昵称' }]"
				/>
				<van-field
					v-model="form.phone"
					name="phone"
					label="账号"
					placeholder="请输入群管账号"
					:rules="[{ required: true, message: '请填写账号' }]"
				/>
				<van-field
					v-model="form.password"
					type="password"
					name="password"
					label="密码"
					placeholder="请输入群管密码"
					:rules="[{ required: true, message: '请填写密码' }]"
				/>
				<van-field
					v-model="form.password_confirm"
					type="password"
					name="password_confirm"
					label="确认密码"
					placeholder="请再次输入密码"
					:rules="[
						{ required: true, message: '请确认密码' },
						{ validator: validatePassword, message: '两次输入密码不一致' }
					]"
				/>
			</van-cell-group>
			<div class="" style="text-align: center;">
				<van-button
					type="primary"
					native-type="submit"
					class="save-btn"
				>
					保存
				</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>

import {defineComponent} from 'vue'
import {groupManagerAdd} from "../../api/homePage";

export default defineComponent({
	name: "addGroupAdmin",
	data() {
		return {
			form: {
                name: '',
                phone: '',
                password: '',
                password_confirm: ''
			}
		}
	},
	created() {
	},
	methods: {
		validatePassword(val) {
			return val === this.form.password
		},
		async onSubmit(values) {
			try {
				const response = await groupManagerAdd(this.form);
				if(response.code == 1) {
                    this.$toast.success('添加群管成功');
                    this.$router.go(-1);
                } else {
                    this.$toast.fail(response.msg);
                }
			} catch (error) {
				console.error('提交失败', error);
				this.$toast.fail(error.message || '添加群管失败');
			}
		}
	}
})
</script>
<style scoped lang="less">
.van-cell {
	padding: var(--base-px-12) 0;
}
.van-field__label {
	width: var(--base-px-80);
}
.save-btn {
	background-color: #0256FF;
	border-radius: var(--base-px-8);
	margin-top: var(--base-px-30);
    height: var(--base-px-45);
    line-height: var(--base-px-45);
    width: 90%;
    border: none;
}

/* 修复placeholder变红问题 */
/deep/ .van-field__control::placeholder {
    color: #969799 !important;
}
</style>
